<template>
	<ModalDialog
		:buttons="[ [{name: 'cancel', caption: $t('cancel'), classes: 'btn-outline-secondary', clickFn: cancelClickedHandler, isDisabled: false}], [{name: 'ok', caption: okButtoncaption, classes: 'btn-success', clickFn: okClickedHandler, isDisabled: isOkDisabled}] ]"
		@escKeyPressed="escKeyPressedHandler"
		size="lg">
		<template v-slot:title>{{ $t('modal_download_document_title') }}</template>
		<template v-slot:infoMessage>
			<span class="d-flex text-left mt-2"><i class="fas fa-info-circle mr-2 mt-1 text-info"></i>{{ $t('download_documents_instructions') }}</span>
		</template>
		<template v-slot:body>
			<div class="position-relative">
				<div class="modal-dialog-header sticky-top row mb-2">
					<div class="col-1 col-form-label"></div>
					<div class="col-2 col-form-label pl-0">{{ $t('title') }} / {{ $t('document_size') }}</div>
					<div class="col-3 col-form-label ">{{ $t('category') }} / {{ $t('subcategory') }}</div>
					<div class="col-2 col-form-label">{{ $t('language') }}</div>
					<div class="col-4 col-form-label">{{ $t('description') }}</div>
				</div>
				<ul class="list-unstyled">
					<template v-for="(document, index) in documentsFilteredSortered">
						<li class="row">
							<div class="col-1 col-form-label"><input  v-if="!checkDocumentIsInternal(document)" type="checkbox" :id="'check-' + index" @change="onCheckClickedHandler(document, $event.target.checked)" :title="document.isChecked ? $t('click_to_unselect_document_to_download') : $t('click_to_select_document_to_download')" :checked="document.isChecked"><i v-if="checkDocumentIsInternal(document)" class="fas fa-exclamation-triangle text-warning" :title="$t('internal_document')"></i></div>
							<div class="col-2 col-form-label pl-0">
								<div class="font-weight-semibold">{{ document.title }}</div>
								<div>{{ document.size }}</div>
							</div>
							<div class="col-3 col-form-label">
								<div class="font-weight-semibold">{{ document.category.title }}</div>
								<div>{{ document.subcategory.title }}</div>
							</div>
							<div class="col-2 col-form-label">{{ document.languagesScreen }}</div>
							<div class="col-4 col-form-label">{{ document.description }}</div>
						</li>
					</template>
				</ul>
			</div>
		</template>
		<template v-slot:errorMessage v-if="errorMessage">
				<span class="font-weight-semibold text-right p-3 border-top text-danger">{{errorMessage}}</span>
		</template>
	</ModalDialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import ModalDialog from './ModalDialog.vue';
import { CONSTANTS } from '../resources/constants.js';
import { utilities } from '../resources/utilities.js';

export default {
	props: ['documentsFiltered', 'seriesName', 'seriesVersion'],

	components: {
		ModalDialog,
	},

	data() {
		return {
			arrayDocumentsTitle: [],
			errorMessage: null,
			waitingForFlow: false,
		};
	},

	computed: {
		...mapState([
			'stateMachine',
			'documentationDocumentLibraries',
		]),

		documentsFilteredSortered() {
			return this.documentsFiltered.filter((d) => d.fileExists).sort(utilities.multiCriteriaSort(['title'], 1)).map((d) => {
				d.isChecked = !this.checkDocumentIsInternal(d);
				return d;
			});
		},

		isOkDisabled() {
			return this.arrayDocumentsTitle.length === 0;
		},

		okButtoncaption() {
			return (this.waitingForFlow ? '<i class="fas fa-spinner spinning mr-2"></i>' : '') + this.$t('download');
		},
	},

	methods: {
		...mapActions([
			'downloadDocuments',
			'getLocalIP',
		]),

		...mapMutations([
			'updateUsageTrackerStorage',
		]),

		cancelClickedHandler() {
			this.$emit('cancelClicked');
		},

		checkDocumentIsInternal(document) {
			return this.documentationDocumentLibraries.find((ddl) => ddl.internalName(this.stateMachine.testMode) === document.libraryName).isInternal;
		},

		escKeyPressedHandler() {
			this.$emit('cancelClicked');
		},

		onCheckClickedHandler(document, checked) {
			if (checked) {
				this.arrayDocumentsTitle.push(document.title);
			} else {
				this.arrayDocumentsTitle = this.arrayDocumentsTitle.filter((dt) => dt !== document.title);
			}
		},

		okClickedHandler() {
			this.waitingForFlow = true;
			this.errorMessage = '';

			this.downloadDocuments({ arrayDocumentsTitle: this.arrayDocumentsTitle, seriesName: this.seriesName, seriesVersion: this.seriesVersion }).then(() => {
				this.waitingForFlow = false;
				this.$emit('okClicked');

				this.getLocalIP().then((localIp) => {
					this.updateUsageTrackerStorage({ field: CONSTANTS.UserSettings.fieldsKeys.downloadDocuments, data: { length: this.arrayDocumentsTitle.length, seriesName: this.seriesName, seriesVersion: this.seriesVersion, arrayDocumentsTitle: this.arrayDocumentsTitle }, localIp });
				});

				this.errorMessage = null;
			}).catch(() => {
				this.waitingForFlow = false;
				this.errorMessage = this.$t('error_preaparing_documentation');
			});
		},
	},

	mounted() {
		this.arrayDocumentsTitle = this.documentsFilteredSortered.filter((d) => d.isChecked).map((d) => d.title);
	},
};
</script>
